import CollapseManager from "../../js/components/collapseManager";

export default class FaqCard extends HTMLElement
{
    connectedCallback()
    {
        this.stylesheet = this.getAttribute('stylesheet');
        let shadowRoot = this.attachShadow({mode: 'open'});
        const faqCard = document.querySelector('#faq-card-container');
        const instance = faqCard.content.cloneNode(true);

        this.iconType = this.getAttribute('icon-type');
        this.noCollapsed = this.getAttribute('no-collapsed');
        this.noBorderBottom = this.getAttribute('no-border-bottom');

        if (this.stylesheet !== undefined)
        {
            instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
             if (this.iconType == 'full') {
                instance.querySelector('[name="faq-question-section"]').classList.add('icon-full');
            }
             if (this.noCollapsed == 'true') {
                 instance.querySelector('[data-entity="collapse"]').classList.remove('collapsed');
             }
             if(this.noBorderBottom == 'true') {
                 instance.querySelector('[name="faq-answer-section"]').classList.add('no-border-bottom');
             }
            shadowRoot.appendChild(instance);
        }

        new CollapseManager(shadowRoot);
        return shadowRoot;
    }
}
